import React, { FC } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

interface IProps {
  isInvalid?: boolean;
  className?: string;
  // @ts-expect-rest props
  [restProps: string]: any;
}

const Textarea: FC<IProps> = ({ isInvalid, className, ...restProps }) => (
  <textarea
    className={classNames(
      css.textarea,
      {
        [css.isInvalid]: isInvalid,
      },
      className,
    )}
    {...restProps}
  />
);

export default Textarea;
